const disableBodyScroll = () => {
  document.body.style.overflow = "hidden";
};
const enableBodyScroll = () => {
  document.body.style.removeProperty("overflow");
};
export {
  disableBodyScroll,
  enableBodyScroll
};
//# sourceMappingURL=scroll.js.map
